module.exports = __webpack_public_path__ + "../public/img/right-arrow.675eb599.png";